// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E6KrR","content":"styles_content__llRGP"};